import React from "react";
import { IconProps } from "./types";

function IconFacebook(props: IconProps) {
  return (
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Vector (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.02512 1.02513C3.6815 0.368749 4.57174 0 5.5 0H7.3C7.57614 0 7.8 0.223858 7.8 0.5V2.9C7.8 3.17614 7.57614 3.4 7.3 3.4H5.5C5.47348 3.4 5.44804 3.41054 5.42929 3.42929C5.41053 3.44804 5.4 3.47348 5.4 3.5V4.8H7.3C7.45396 4.8 7.59935 4.87094 7.6941 4.99229C7.78885 5.11365 7.82241 5.2719 7.78507 5.42127L7.18507 7.82127C7.12942 8.04385 6.92943 8.2 6.7 8.2H5.4V12.5C5.4 12.7761 5.17614 13 4.9 13H2.5C2.22385 13 2 12.7761 2 12.5V8.2H0.699997C0.423855 8.2 0.199997 7.97614 0.199997 7.7V5.3C0.199997 5.02386 0.423855 4.8 0.699997 4.8H2V3.5C2 2.57174 2.36875 1.6815 3.02512 1.02513ZM5.5 1C4.83696 1 4.20107 1.26339 3.73223 1.73223C3.26339 2.20107 3 2.83696 3 3.5V5.3C3 5.57614 2.77614 5.8 2.5 5.8H1.2V7.2H2.5C2.77614 7.2 3 7.42386 3 7.7V12H4.4V7.7C4.4 7.42386 4.62385 7.2 4.9 7.2H6.30961L6.65961 5.8H4.9C4.62385 5.8 4.4 5.57614 4.4 5.3V3.5C4.4 3.20826 4.51589 2.92847 4.72218 2.72218C4.92847 2.51589 5.20826 2.4 5.5 2.4H6.8V1H5.5Z"
        fill="#1E293B"
      />
    </svg>
  );
}

export default IconFacebook;
